var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-row",
    {
      attrs: {
        "vs-justify": _vm.description ? "space-between" : "center",
        "vs-type": "flex",
        "vs-w": "12",
      },
    },
    [
      _vm.description
        ? _c(
            "vs-col",
            {
              staticClass: "vs-pagination--mb",
              attrs: {
                "vs-type": "flex",
                "vs-justify": "flex-start",
                "vs-align": "center",
                "vs-lg": "6",
                "vs-sm": "12",
                "vs-xs": "12",
              },
            },
            [
              _c("div", [
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.descriptionTitle) +
                      ": " +
                      _vm._s(_vm.minRows) +
                      " - " +
                      _vm._s(_vm.maxRows) +
                      " " +
                      _vm._s(_vm.descriptionConnector) +
                      " " +
                      _vm._s(_vm.sizeArray) +
                      " | " +
                      _vm._s(_vm.descriptionBody) +
                      ":\n\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "vs-pagination--array" },
                  _vm._l(_vm.descriptionItems, function (row, index) {
                    return _c("li", { key: index }, [
                      _c(
                        "span",
                        {
                          class: [
                            `vs-description-${_vm.color}`,
                            { "vs-pagination--bold": index == _vm.indexRows },
                          ],
                          style: _vm.styleDescription,
                          on: {
                            click: function ($event) {
                              return _vm.changeRowMaxItems(index)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" + _vm._s(row) + "\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      index != _vm.descriptionItems.length - 1
                        ? _c("span", [_vm._v(",")])
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "vs-col",
        {
          staticClass: "vs-pagination--mb",
          attrs: {
            "vs-lg": _vm.description ? 6 : 12,
            "vs-type": "flex",
            "vs-justify": "flex-end",
            "vs-align": "center",
            "vs-sm": "12",
            "vs-xs": "12",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "con-vs-pagination",
              class: [`vs-pagination-${_vm.color}`],
              style: _vm.stylePagination,
            },
            [
              _c("nav", { staticClass: "vs-pagination--nav" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev",
                    class: { disabled: _vm.current <= 1 ? "disabled" : null },
                    attrs: { disabled: _vm.current === 1, type: "button" },
                    on: { click: _vm.prevPage },
                  },
                  [
                    _c("vs-icon", {
                      attrs: {
                        "icon-pack": _vm.iconPack,
                        icon: _vm.prevIcon ? _vm.prevIcon : _vm.defaultPrevIcon,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "vs-pagination--ul" },
                  _vm._l(_vm.pages, function (page, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "item-pagination vs-pagination--li",
                        class: { "is-current": page == _vm.current },
                        on: {
                          click: function ($event) {
                            return _vm.goTo(page)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" + _vm._s(page) + "\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "effect" }),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "vs-pagination--buttons btn-next-pagination vs-pagination--button-next",
                    class: {
                      disabled: _vm.current === _vm.total ? "disabled" : null,
                    },
                    attrs: {
                      disabled: _vm.current === _vm.total,
                      type: "button",
                    },
                    on: { click: _vm.nextPage },
                  },
                  [
                    _c("vs-icon", {
                      attrs: {
                        "icon-pack": _vm.iconPack,
                        icon: _vm.nextIcon ? _vm.nextIcon : _vm.defaultNextIcon,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.goto
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.go,
                          expression: "go",
                        },
                      ],
                      staticClass: "vs-pagination--input-goto",
                      attrs: { max: _vm.total, min: "1", type: "number" },
                      domProps: { value: _vm.go },
                      on: {
                        change: _vm.goTo,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.go = $event.target.value
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }